
export { CollectionName } from "/codebuild/output/src4004174258/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"